import React, { createContext, useContext, useMemo, useCallback, useEffect, useState } from 'react';
import { getCategories } from '../services/CategoryService';

const CategoriesContext = createContext({
  categories: null,
  isLoading: false,
  error: null,
  refetch: () => {}
});

export const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const { data, meta } = await getCategories();
      if (meta) {
        setError(meta);
      }
      setCategories(data || []);
    } catch (err) {
      setError(err);
      setCategories([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  const value = useMemo(() => ({
    categories,
    isLoading,
    error,
    refetch: fetchCategories
  }), [categories, isLoading, error, fetchCategories]);

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => useContext(CategoriesContext);
